import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Analytics } from './net/analytics.js'
import { Home } from './screens/Home.js'
import { Learn } from './screens/Learn.js'
import { Play } from './screens/Play.js'
import { BoardScreen } from './screens/BoardScreen.js'
import { Rules } from './screens/Rules.js'
import { NotFound } from './screens/NotFound.js'
import { Faq } from './screens/content/Faq.js'
import { PlayerCount } from './screens/content/PlayerCount.js'

/**
 * Every route, without a router around them.
 *
 * Split out so the prerenderer can wrap the same tree in a `StaticRouter` and
 * render it to a string at build time - see `entry-server.tsx`. A component
 * that mounted its own `BrowserRouter` could not be rendered off a browser at
 * all, and two route tables, one per renderer, is the kind of duplication that
 * ships a page the crawler sees and nobody else does.
 *
 * Deliberately does not import `styles.css`: that belongs to `main.tsx`, and
 * keeping it there is what lets the SSR build skip CSS handling entirely.
 */
export function AppRoutes() {
  return (
    <>
      {/* Inside the router, because what it reports is which route is on. */}
      <Analytics />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/join/:code" element={<Home />} />
        <Route path="/play/:code" element={<Play />} />
        <Route path="/board/:code" element={<BoardScreen />} />
        <Route path="/learn" element={<Learn />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/play-with/:count" element={<PlayerCount />} />
        <Route path="/faq" element={<Faq />} />
        {/*
          A real page, not a redirect to `/`. A silent bounce to the home
          screen tells a person nothing about the link they followed, and tells
          a crawler that every misspelling is a duplicate of the front page.
        */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}

export function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  )
}
